module.exports = __webpack_public_path__ + "media/images/favicons/android-icon-192x192-1cddc20faf27b57c63761c8ffbfbf123.png";